export default "__VITE_ASSET__RXf7niNM__"